import { render, staticRenderFns } from "./AccreditationForm.vue?vue&type=template&id=5d5f6968&scoped=true&"
import script from "./AccreditationForm.vue?vue&type=script&lang=js&"
export * from "./AccreditationForm.vue?vue&type=script&lang=js&"
import style0 from "./AccreditationForm.vue?vue&type=style&index=0&id=5d5f6968&scoped=true&lang=css&"
import style1 from "./AccreditationForm.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5f6968",
  null
  
)

export default component.exports